import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import secondaryComponents from "../../../../components/secondaryComponents";
import primaryComponents from "../../../../components/primaryComponents";
import useAllReconciliations from "../../../appPages/Inventory/Reconciliation/AllReconciliations/useAllReconciliations";
import { useEffect } from "react";
import { ReconcileIcon } from "../../../../assets/svgIcons";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const SMReconciliationHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const {
    isFetchingReconciliations,
    reconciliations,
    metaDetails,
    search,
    isStartingReconcile,
    reconcile,
    filterByStoreId,
    gotoPage,
    handleFetchReconciliations,
  } = useAllReconciliations();

  useEffect(() => {
    if (!search.get("store_id")) filterByStoreId(store_id);
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Reconciliations"
      headerDescription="Compare and adjust your inventory records with your physical inventory counts here"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <secondaryComponents.NavigateWithPermission
        permissionParentKey={"Inventory Management"}
        permissionChildKey="can_create_and_submit_reconciliation"
      >
        <primaryComponents.Button
          classNames="btn btn--primary ml-auto"
          isDisabled={isStartingReconcile}
          isLoading={isStartingReconcile}
          loadingText={"Proccessing..."}
          onClick={() => reconcile({ store: store_id })}
        >
          <ReconcileIcon className="mr-1" />
          Reconcile Stock
        </primaryComponents.Button>
      </secondaryComponents.NavigateWithPermission>

      <secondaryComponents.LoaderHelper
        isLoading={isFetchingReconciliations}
        classNames="mt-5"
      >
        <div className={`${globalStyles.cardWithBorder} p-0`}>
          <secondaryComponents.ReconciliationsTable
            reconciliations={reconciliations}
            metaDetails={metaDetails}
            gotoPage={gotoPage}
            handleFetchReconciliations={handleFetchReconciliations}
          />
        </div>
      </secondaryComponents.LoaderHelper>
    </RoutedModal>
  );
};
